import ModelBase from "./shared/model-base.js";

export interface RateEntry {
  currency_code: string;
  rate: number;
  source: string | null;
  fetched_at: string | null;
}

interface ModelAttributes {
  id: string | number;
  rate_date?: string;
  rates?: RateEntry[];
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "exchange_report",
  columns: ["id", "rate_date", "rates", "created_at", "updated_at"],
  editColumns: {},
};

export default class ExchangeReport extends ModelBase {
  declare id: string | number;
  declare rate_date: string;
  declare rates: RateEntry[];
  declare created_at: string;
  declare updated_at: string;

  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }

  // 回傳指定 currency 的「第一筆」rate（每 currency 通常只有 1 source）
  rateFor(currency: string): RateEntry | undefined {
    return this.rates?.find((r) => r.currency_code === currency);
  }

  // 回傳指定 currency 的「所有」rate（多 source 並存時用）
  ratesFor(currency: string): RateEntry[] {
    return this.rates?.filter((r) => r.currency_code === currency) ?? [];
  }
}
